'use strict';
import * as $j_app$002eapi$002e$002dDrug$002dRequest$002dCorrespondent$0024$002dGeneral$002dPractice from "./app.api.-Drug-Request-Correspondent$-General-Practice.js";
import * as $j_app$002edata$002etypes$005fdrug$0024package$0024$002dDrug$002dRequest$002dAccepted$002dNote$0024 from "./app.data.types_drug$package$-Drug-Request-Accepted-Note$.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest(drugReqId, practice, drugRequest, yourResponse, seen, maybeEpsCode, gpNote) {
  this.Lapp_api_DrugRequestsAcceptedListItem$DrugRequest__f_drugReqId = null;
  this.Lapp_api_DrugRequestsAcceptedListItem$DrugRequest__f_practice = null;
  this.Lapp_api_DrugRequestsAcceptedListItem$DrugRequest__f_drugRequest = null;
  this.Lapp_api_DrugRequestsAcceptedListItem$DrugRequest__f_yourResponse = null;
  this.Lapp_api_DrugRequestsAcceptedListItem$DrugRequest__f_seen = false;
  this.Lapp_api_DrugRequestsAcceptedListItem$DrugRequest__f_maybeEpsCode = null;
  this.Lapp_api_DrugRequestsAcceptedListItem$DrugRequest__f_gpNote = null;
  this.Lapp_api_DrugRequestsAcceptedListItem$DrugRequest__f_drugReqId = drugReqId;
  this.Lapp_api_DrugRequestsAcceptedListItem$DrugRequest__f_practice = practice;
  this.Lapp_api_DrugRequestsAcceptedListItem$DrugRequest__f_drugRequest = drugRequest;
  this.Lapp_api_DrugRequestsAcceptedListItem$DrugRequest__f_yourResponse = yourResponse;
  this.Lapp_api_DrugRequestsAcceptedListItem$DrugRequest__f_seen = seen;
  this.Lapp_api_DrugRequestsAcceptedListItem$DrugRequest__f_maybeEpsCode = maybeEpsCode;
  this.Lapp_api_DrugRequestsAcceptedListItem$DrugRequest__f_gpNote = gpNote;
}
export { $c_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest as $c_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest };
$c_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest.prototype.constructor = $c_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest;
/** @constructor */
function $h_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest() {
}
export { $h_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest as $h_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest };
$h_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest.prototype = $c_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest.prototype;
$c_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest.prototype.correspondent__Lapp_api_DrugRequestCorrespondent = (function() {
  var details = this.Lapp_api_DrugRequestsAcceptedListItem$DrugRequest__f_practice;
  return new $j_app$002eapi$002e$002dDrug$002dRequest$002dCorrespondent$0024$002dGeneral$002dPractice.$c_Lapp_api_DrugRequestCorrespondent$GeneralPractice(details);
});
$c_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 675570861, true);
});
$c_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest)) {
    var x = this.Lapp_api_DrugRequestsAcceptedListItem$DrugRequest__f_drugReqId;
    var x$2 = x$0.Lapp_api_DrugRequestsAcceptedListItem$DrugRequest__f_drugReqId;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lapp_api_DrugRequestsAcceptedListItem$DrugRequest__f_practice;
      var x$4 = x$0.Lapp_api_DrugRequestsAcceptedListItem$DrugRequest__f_practice;
      var $x_4 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$5 = this.Lapp_api_DrugRequestsAcceptedListItem$DrugRequest__f_drugRequest;
      var x$6 = x$0.Lapp_api_DrugRequestsAcceptedListItem$DrugRequest__f_drugRequest;
      var $x_3 = ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$7 = this.Lapp_api_DrugRequestsAcceptedListItem$DrugRequest__f_yourResponse;
      var x$8 = x$0.Lapp_api_DrugRequestsAcceptedListItem$DrugRequest__f_yourResponse;
      var $x_2 = ((x$7 === null) ? (x$8 === null) : x$7.equals__O__Z(x$8));
    } else {
      var $x_2 = false;
    }
    if (($x_2 && (this.Lapp_api_DrugRequestsAcceptedListItem$DrugRequest__f_seen === x$0.Lapp_api_DrugRequestsAcceptedListItem$DrugRequest__f_seen))) {
      var x$9 = this.Lapp_api_DrugRequestsAcceptedListItem$DrugRequest__f_maybeEpsCode;
      var x$10 = x$0.Lapp_api_DrugRequestsAcceptedListItem$DrugRequest__f_maybeEpsCode;
      var $x_1 = ((x$9 === null) ? (x$10 === null) : x$9.equals__O__Z(x$10));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return (this.Lapp_api_DrugRequestsAcceptedListItem$DrugRequest__f_gpNote === x$0.Lapp_api_DrugRequestsAcceptedListItem$DrugRequest__f_gpNote);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest.prototype.productArity__I = (function() {
  return 7;
});
$c_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest.prototype.productPrefix__T = (function() {
  return "DrugRequest";
});
$c_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lapp_api_DrugRequestsAcceptedListItem$DrugRequest__f_drugReqId;
      break;
    }
    case 1: {
      return this.Lapp_api_DrugRequestsAcceptedListItem$DrugRequest__f_practice;
      break;
    }
    case 2: {
      return this.Lapp_api_DrugRequestsAcceptedListItem$DrugRequest__f_drugRequest;
      break;
    }
    case 3: {
      return this.Lapp_api_DrugRequestsAcceptedListItem$DrugRequest__f_yourResponse;
      break;
    }
    case 4: {
      return this.Lapp_api_DrugRequestsAcceptedListItem$DrugRequest__f_seen;
      break;
    }
    case 5: {
      return this.Lapp_api_DrugRequestsAcceptedListItem$DrugRequest__f_maybeEpsCode;
      break;
    }
    case 6: {
      return this.Lapp_api_DrugRequestsAcceptedListItem$DrugRequest__f_gpNote;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "drugReqId";
      break;
    }
    case 1: {
      return "practice";
      break;
    }
    case 2: {
      return "drugRequest";
      break;
    }
    case 3: {
      return "yourResponse";
      break;
    }
    case 4: {
      return "seen";
      break;
    }
    case 5: {
      return "maybeEpsCode";
      break;
    }
    case 6: {
      return "gpNote";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest.prototype.drugRequest__Lapp_api_DrugRequestData = (function() {
  return this.Lapp_api_DrugRequestsAcceptedListItem$DrugRequest__f_drugRequest;
});
$c_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest.prototype.seen__Z = (function() {
  return this.Lapp_api_DrugRequestsAcceptedListItem$DrugRequest__f_seen;
});
$c_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest.prototype.maybeEpsCode__s_Option = (function() {
  return this.Lapp_api_DrugRequestsAcceptedListItem$DrugRequest__f_maybeEpsCode;
});
$c_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest.prototype.gpNoteString__T = (function() {
  var target = this.Lapp_api_DrugRequestsAcceptedListItem$DrugRequest__f_gpNote;
  var tc = $j_app$002edata$002etypes$005fdrug$0024package$0024$002dDrug$002dRequest$002dAccepted$002dNote$0024.$m_Lapp_data_types\uff3fdrug$package$DrugRequestAcceptedNote$().given_Show_Type__Lcats_Show();
  var this$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$ToShowOps$$anon$3(target, tc);
  return this$3.Lcats_Show$ToShowOps$$anon$3__f_typeClassInstance.show__O__T(this$3.Lcats_Show$ToShowOps$$anon$3__f_self);
});
function $isArrayOf_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_api_DrugRequestsAcceptedListItem$DrugRequest)));
}
export { $isArrayOf_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest as $isArrayOf_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest };
var $d_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest, "app.api.DrugRequestsAcceptedListItem$DrugRequest", ({
  Lapp_api_DrugRequestsAcceptedListItem$DrugRequest: 1,
  Lapp_api_DrugRequestCardData: 1,
  Lapp_api_DrugRequestsAcceptedListItem: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest as $d_Lapp_api_DrugRequestsAcceptedListItem$DrugRequest };
//# sourceMappingURL=app.api.-Drug-Requests-Accepted-List-Item$-Drug-Request.js.map
